import { createTheme, createVariant, globalTheme } from '@cld/component-theme';
import { FieldValidationState } from '@cld/common-definitions';

const { palette } = globalTheme;

export const radioTheme = createTheme({
  size: '0.875rem',
  background: {
    color: {
      base: palette.surfaceAlt,
      hover: palette.surfaceAlt,
      focus: palette.surfaceAlt,
      disabled: palette.surfaceAlt,
    },
  },
  radio: {
    size: '0.5rem',
    color: {
      disabled: palette.secondaryAlt,
    },
  },
  border: {
    color: {
      base: palette.secondaryAlt,
      disabled: palette.secondaryAlt,
    },
  },
  focus: {
    shadow: {
      size: '3px',
    },
    color: palette.primary,
  },
  // variants
  none: {
    radio: {
      color: {
        active: palette.primary,
      },
    },
    border: {
      color: {
        base: palette.secondaryAlt,
        hover: palette.primary,
        active: palette.primary,
      },
    },
  },
  success: {
    radio: {
      color: {
        active: palette.success,
      },
    },
    border: {
      color: {
        base: palette.success,
        hover: palette.success,
        active: palette.success,
      },
    },
  },
  error: {
    radio: {
      color: {
        active: palette.error,
      },
    },
    border: {
      color: {
        base: palette.error,
        hover: palette.error,
        active: palette.error,
      },
    },
  },
  warning: {
    radio: {
      color: {
        active: palette.warning,
      },
    },
    border: {
      color: {
        base: palette.warning,
        hover: palette.warning,
        active: palette.warning,
      },
    },
  },
});

export interface RadioThemeProps {
  validationState: FieldValidationState;
}

export const typeVariant = createVariant((props: RadioThemeProps) => radioTheme[props.validationState]);
